import React from 'react';
import { Typography, Button, Box, IconButton } from '@material-ui/core';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { Link, useLocation } from 'react-router-dom';
import PointsValue from '../UI/PointsValue';
import { useStyles } from './styles';

const ProductCard = ({ data, isFavoriteDefault = false, onToggleFavorite, propNames = [], withoutLink = false }) => {
    const classes = useStyles();
    const location = useLocation();
    const { id, images, image, name, priceStr, price_old, points, isFavorite = isFavoriteDefault, properties } = data;

    const handleFavorite = () => {
        if (isFavorite) {
            onToggleFavorite(id, 'remove');
        } else {
            onToggleFavorite(id, 'add');
        }
    };

    const renderProperty = (name, value, hint, index) => {
        return (
            <Box display="flex" justifyContent="space-between" mb={1} key={index}>
                <Typography variant="body2">{name}</Typography>
                <Typography variant="body2">
                    {typeof value !== 'object' && value} {hint}
                </Typography>
            </Box>
        );
    };

    return (
        <Box className={classes.root}>
            <IconButton className={classes.favoriteBtn} onClick={handleFavorite}>
                <FavoriteIcon color={isFavorite ? 'primary' : 'inherit'} />
            </IconButton>
            {withoutLink ? (
                <div className={classes.imgWrap}>
                    <img className={classes.img} src={images ? images?.length && images[0] : image} alt="" />
                </div>
            ) : (
                <Link to={`${location.pathname}/${id}`} className={classes.link}>
                    <div className={classes.imgWrap}>
                        <img className={classes.img} src={images ? images?.length && images[0] : image} alt="" />
                    </div>
                </Link>
            )}

            <Box textAlign="center" flex={1} mb={3}>
                {withoutLink ? (
                    <Typography className={classes.title}>{name}</Typography>
                ) : (
                    <Link to={`${location.pathname}/${id}`} className={classes.link}>
                        <Typography className={classes.title}>{name}</Typography>
                    </Link>
                )}
            </Box>

            {propNames?.length ? (
                <Box mb={2} flex={1}>
                    {propNames.map((propName, index) => {
                        const prop = properties[propName];
                        if (prop) {
                            return renderProperty(prop.name, prop.value, prop.hint, index);
                        }
                        return null;
                    })}
                </Box>
            ) : null}

            <Box textAlign="center">
                <Box mb={2}>
                    <div className={classes.newPrice}>{priceStr}</div>
                </Box>
                {price_old && <div className={classes.oldPrice}>{price_old}</div>}
                {points && <PointsValue>{points}</PointsValue>}
            </Box>

            {!withoutLink && (
                <Box mt={3} textAlign="center">
                    <Link to={`${location.pathname}/${id}`} className={classes.link}>
                        <Button variant="outlined" color="primary" fullWidth>
                            Подробнее
                        </Button>
                    </Link>
                </Box>
            )}
        </Box>
    );
};

export default ProductCard;
